// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 11802-投诉详情查询 GET /web/v1/complaint/detail/${param0} */
export async function getSwimComplaintDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getSwimComplaintDetailParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimComplaintDetailRespVo>(
    `/web/v1/complaint/detail/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 11803-投诉处理 POST /web/v1/complaint/handle */
export async function handleSwimComplaint(
  body: API.SwimComplaintHandleVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/complaint/handle", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 11801-投诉列表查询 POST /web/v1/complaint/list */
export async function getSwimComplaintPageList(
  body: API.SwimComplaintPageQueryVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOYmPageResVOSwimComplaintListRespVo>(
    "/web/v1/complaint/list",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 11804-投诉日志查询 GET /web/v1/complaint/logList */
export async function getSwimComplaintLogList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getSwimComplaintLogListParams,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOListSwimComplaintLogRespVo>(
    "/web/v1/complaint/logList",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}
